export const HOST_SELECTOR = ":host";

export const RealmCSSVarConst = {
  OPERATOR: "op",
  COMPARATOR: "comp",
  VALUE: "value",
  STYLE: "style",
  GLOBAL: "global",
} as const;
